<!-- ================= NAMED ================= -->
<ng-container *ngIf="serviceTypeId ===1">
  <!--<div class="dialog-body">-->
  <div class="charity-lookup-overlay">
    <div class="charity-lookup-dialog" cdkDrag cdkDragBoundary=".charity-lookup-overlay"
         (mousedown)="$event.stopPropagation()">
      <div class="charity-lookup-header" cdkDragHandle>
        <h3>Beneficiary Lookup</h3>
        <button class="close-btn" (click)="closeBeneficiaryLookup()" title="Close">✕</button>
      </div>

      <div class="charity-lookup-content">
        <!-- SEARCH FIELDS -->
        <div class="search-fields-row">

          <div class="search-field search-field-large">
            <label style="text-align: center">Beneficiary Name</label>
            <div class="input-with-clear">
              <input type="text"
                     [(ngModel)]="beneficiarySearchQuery.beneficiaryName"
                     (keydown)="onBeneficiarySearchKeydown($event)"
                     placeholder="Enter beneficiary name"
                     class="search-input" />
              <button type="button" class="clear-input-btn"
                      [disabled]="!beneficiarySearchQuery.beneficiaryName"
                      (click)="beneficiarySearchQuery.beneficiaryName=''; onBeneficiarySearch()">
                ×
              </button>
            </div>
          </div>

          <div class="search-field search-field-urn">
            <label style="text-align: center">URN</label>
            <div class="input-with-clear">
              <input type="text"
                     [(ngModel)]="beneficiarySearchQuery.beneficiaryURN"
                     (keydown)="onBeneficiarySearchKeydown($event)"
                     class="search-input" />
              <button type="button" class="clear-input-btn"
                      [disabled]="!beneficiarySearchQuery.beneficiaryURN"
                      (click)="beneficiarySearchQuery.beneficiaryURN=''; onBeneficiarySearch()">
                ×
              </button>
            </div>
          </div>

          <div class="search-field search-field-postcode">
            <label style="text-align: center">Postcode</label>
            <div class="input-with-clear">
              <input type="text"
                     [(ngModel)]="beneficiarySearchQuery.postcode"
                     (keydown)="onBeneficiarySearchKeydown($event)"
                     class="search-input" />
            </div>
          </div>

          <div class="search-field search-field-address">
            <label style="text-align: center">Address</label>
            <div class="input-with-clear">
              <input type="text"
                     [(ngModel)]="beneficiarySearchQuery.address"
                     (keydown)="onBeneficiarySearchKeydown($event)"
                     class="search-input" />
            </div>
          </div>

          <div class="search-field search-field-button">
            <label>&nbsp;</label>
            <button class="search-btn" (click)="onBeneficiarySearch()">Search</button>
          </div>


        </div>
        <!-- NEW: Show selected only toggle for beneficiaries -->
        <div style="display: flex; align-items: center; gap: 8px; padding-left: 12px; justify-content: flex-end;">
          <label style="display:inline-flex; align-items:center; gap:6px;">
            <input type="checkbox" [checked]="showOnlySelectedBeneficiaries" (change)="toggleShowOnlySelectedBeneficiaries()" />
            <span style="font-size:12px; color:#243b6b; font-weight:600;">Show selected only</span>
          </label>
        </div>

        <!-- SEARCH RESULTS -->
        <div class="search-results-container items-scroll-wrapper">
          <table class="results-table" *ngIf="beneficiarySearchResults.length &gt;0">
            <thead style=" background: linear-gradient(90deg, #e8f0ff, #ffffff);">
              <tr>  
                <th style="width:36px;">
                  <!-- Header checkbox without arrow functions -->
                  <input type="checkbox"
                         [checked]="allSelected"
                         [indeterminate]="someSelected && !allSelected"
                         (change)="$event.target.checked ? selectAllVisible() : clearAllVisible()"
                         aria-label="Select all" />
                </th>
                <th>Name</th>
                <th>URN</th>
                <th>Postcode</th>
                <th>Address</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let result of beneficiarySearchResults; trackBy: trackById"
                  (click)="toggleBeneficiary(result)"
                  [class.selected]="isSelected(result)">
                <td (click)="$event.stopPropagation()">
                  <input type="checkbox"
                         [checked]="isSelected(result)"
                         (change)="toggleBeneficiary(result)"
                         aria-label="Select beneficiary" />
                </td>
                <td>
                  <span #cell
                        (mouseenter)="showTooltip(result.id, result.aliases, result.previousNames, cell)"
                        (mouseleave)="hideTooltip(result.id)"
                        [style.font-weight]="result.isClient ? '900' : 'normal'"
                        style="cursor: pointer; display:inline-block;">
                    {{ result.name }}
                  </span>
                </td>
                <td style="text-align:center">{{ result.beneficiarySourceURN }}</td>
                <td style="text-align:center">{{ result.postcode }}</td>
                <td>{{ result.addressLine1 }}</td>
              </tr>
            </tbody>
          </table>

          <!-- Hover popup toolbox for alias & previous names (rendered outside table rows) -->
          <div *ngFor="let result of beneficiarySearchResults">
            <div *ngIf="tooltipVisible[result.id]" class="hover-card-fixed"
                 [ngStyle]="{ top: tooltipPosition[result.id]?.top + 'px', left: tooltipPosition[result.id]?.left + 'px' }"
                 (mouseenter)="onTooltipMouseEnter(result.id)"
                 (mouseleave)="onTooltipMouseLeave(result.id)">
              <div class="tooltip-columns">
                <!-- Aliases Section -->
                <div class="tooltip-column">
                  <div class="tooltip-section-header">Aliases</div>
                  <ng-container *ngIf="tooltipContent[result.id]?.aliases?.length; else noAliases">
                    <div *ngFor="let alias of tooltipContent[result.id].aliases" class="tooltip-item">{{ alias }}</div>
                  </ng-container>
                  <ng-template #noAliases>
                    <div class="tooltip-item-empty">None</div>
                  </ng-template>
                </div>

                <!-- Former Names Section -->
                <div class="tooltip-column">
                  <div class="tooltip-section-header">Former Names</div>
                  <ng-container *ngIf="tooltipContent[result.id]?.previousNames?.length; else noFormerNames">
                    <div *ngFor="let formerName of tooltipContent[result.id].previousNames" class="tooltip-item">{{ formerName }}</div>
                  </ng-container>
                  <ng-template #noFormerNames>
                    <div class="tooltip-item-empty">None</div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>

          <!-- NO RESULTS + ADD BENEFICIARY -->
          <div class="no-results" *ngIf="beneficiarySearchResults.length ===0">

            <p>No results found.</p>

            <button class="search-btn" (click)="toggleAddBeneficiaryForm()">
              Add New Beneficiary
            </button>

            <mat-expansion-panel [expanded]="showAddBeneficiaryForm">

              <form (ngSubmit)="saveNewBeneficiary()" class="two-column-row">

                <mat-form-field class="w-100">
                  <mat-label>URN</mat-label>
                  <input matInput [(ngModel)]="newBeneficiary.beneficiarySourceURN" name="urn">
                </mat-form-field>

                <mat-form-field class="w-100">
                  <mat-label>Name</mat-label>
                  <input matInput [(ngModel)]="newBeneficiary.name" name="name">
                </mat-form-field>


                <mat-form-field class="w-100">
                  <mat-label>Address Line1</mat-label>
                  <input matInput [(ngModel)]="newBeneficiary.addressLine1" name="address1">
                </mat-form-field>

                <mat-form-field class="w-100">
                  <mat-label>Address Line2</mat-label>
                  <input matInput [(ngModel)]="newBeneficiary.addressLine2" name="address2">
                </mat-form-field>

                <mat-form-field class="w-100">
                  <mat-label>Postcode</mat-label>
                  <input matInput [(ngModel)]="newBeneficiary.postcode" name="postcode">
                </mat-form-field>

                <mat-form-field class="w-100">
                  <mat-label>Email</mat-label>
                  <input matInput [(ngModel)]="newBeneficiary.email" name="email">
                </mat-form-field>

              </form>

              <button class="apply-btn" type="submit">Save</button>

              <div *ngIf="alert.text" class="alert">
                {{ alert.text }}
              </div>

            </mat-expansion-panel>

          </div>
        </div>

      </div>
      <!-- APPLY BUTTONS -->
      <div mat-dialog-actions align="end" class="footer-btn">
        <div class="results-count-updated">
          <p>Found {{beneficiarySearchResults.length}} results(s).</p>
        </div>
        <div>
          <button mat-button (click)="cancel()" style=" background: #f1f5f9; border: 1px solid #dbe3f8; color: #2f3f66;">Cancel</button>
          <button mat-raised-button style="background: linear-gradient(135deg, #7c3aed, #6d28d9); color: white;" (click)="save()">Save</button>
        </div>
      </div>
    </div>
  </div>
  <!--</div>-->
</ng-container>

<!-- ================= DISCRETIONARY ================= -->

<ng-container *ngIf="serviceTypeId ===2">
  <!-- Discretionary Category Lookup Popup -->
  <div class="category-popup-overlay" *ngIf="isDiscretionaryCategoryPopupOpen" (mousedown)="onDiscretionaryCategoryOverlayMouseDown($event)">
    <div class="category-popup-dialog category-popup-dialog-wide" cdkDrag cdkDragBoundary=".category-popup-overlay" (mousedown)="$event.stopPropagation()">
      <div class="category-popup-header" cdkDragHandle>
        <h3>Category Lookup</h3>
        <button class="close-btn" (click)="closeDiscretionaryCategoryPopup()" title="Close">✕</button>
      </div>
      <div class="category-popup-content category-popup-single-column">
        <!-- Activities Column (Single list showing Parent - Child) -->
        <div class="activity-column activity-column-full">
          <div class="activity-search-box">
            <input type="text" placeholder="Search activities..."
                   [(ngModel)]="activitySearchTerm"
                   (ngModelChange)="filterActivities()"
                   class="activity-search-input" />
          </div>
          <div style="padding-left:12px; padding-top:12px; display: flex; gap:8px; align-items: center; justify-content: space-between;">
            <input type="checkbox" (change)="($event.target.checked ? selectAllVisibleActivities() : clearAllVisibleActivities())" />
            <!-- NEW: toggle to show only selected -->
            <label style="margin-left:8px; display:inline-flex; align-items:center; gap:6px; padding-right:24px">
              <input type="checkbox" [checked]="showOnlySelectedActivities" (change)="toggleShowOnlySelectedActivities()" />
              <span style="font-size:12px; color:#243b6b; font-weight:600;">Show selected only</span>
            </label>
          </div>
          <div class="activity-checkbox-list" [class.empty-list]="filteredActivitiesList.length ===0">
            <div *ngIf="filteredActivitiesList.length ===0" class="empty-list-message">
              No activities found
            </div>
            <label *ngFor="let activity of filteredActivitiesList" class="activity-checkbox-item">
              <input type="checkbox"
                     [checked]="isActivitySelected(activity)"
                     (change)="toggleActivity(activity)" />
              <span class="checkbox-label">{{ activity.parent }} - {{ activity.child }}</span>
            </label>
          </div>
        </div>
      </div>

      <div class="category-popup-footer">
        <button class="btn btn-secondary" (click)="closeDiscretionaryCategoryPopup()">Cancel</button>
        <button class="btn btn-primary" (click)="applyDiscretionaryCategories()">Save</button>
      </div>
    </div>
  </div>

  <!-- Region Lookup Popup -->
  <div class="category-popup-overlay" *ngIf="isDiscretionaryRegionPopupOpen" (mousedown)="onDiscretionaryCategoryOverlayMouseDown($event)">
    <div class="category-popup-dialog category-popup-dialog-wide" cdkDrag cdkDragBoundary=".category-popup-overlay" (mousedown)="$event.stopPropagation()">
      <div class="category-popup-header" cdkDragHandle>
        <h3>Region Lookup</h3>
        <button class="close-btn" (click)="closeDiscretionaryRegionPopup()" title="Close">✕</button>
      </div>

      <div class="category-popup-content category-popup-single-column">
        <div class="activity-column activity-column-full">
          <div class="activity-search-box">
            <input type="text" placeholder="Search regions..."
                   [(ngModel)]="regionSearchTerm"
                   (ngModelChange)="filterRegions()"
                   class="activity-search-input" />
          </div>
          <div style="padding-left:12px; padding-top:12px; display: flex; gap:8px; align-items: center; justify-content: space-between;">
            <input type="checkbox" (change)="($event.target.checked ? selectAllVisibleRegions() : clearAllVisibleRegions())" />
            <!-- NEW: toggle to show only selected regions -->
            <label style="margin-left:8px; display: inline-flex; align-items: center; gap:6px; padding-right:24px">
              <input type="checkbox" [checked]="showOnlySelectedRegions" (change)="toggleShowOnlySelectedRegions()" />
              <span style="font-size:12px; color:#243b6b; font-weight:600;">Show selected only</span>
            </label>
          </div>
          <div class="activity-checkbox-list" [class.empty-list]="filteredRegionList.length ===0">
            <div *ngIf="filteredRegionList.length ===0" class="empty-list-message">
              No regions found
            </div>
            <label *ngFor="let activity of filteredRegionList" class="activity-checkbox-item">
              <input type="checkbox"
                     [checked]="isRegionSelected(activity)"
                     (change)="toggleRegion(activity)" />
              <span class="checkbox-label">{{ activity.name }}</span>
            </label>
          </div>
        </div>
      </div>

      <div class="category-popup-footer">
        <button class="btn btn-secondary" (click)="closeDiscretionaryRegionPopup()">Cancel</button>
        <button class="btn btn-primary" (click)="applyDiscretionaryRegions()">Save</button>
      </div>
    </div>
  </div>
</ng-container>

<!--- ================Trust ==================================-->
<ng-container *ngIf="serviceTypeId === 3">
  <!-- Discretionary Category Lookup Popup -->
  <div class="category-popup-overlay" *ngIf="isDiscretionaryCategoryPopupOpen" (mousedown)="onDiscretionaryCategoryOverlayMouseDown($event)">
    <div class="category-popup-dialog category-popup-dialog-wide" cdkDrag cdkDragBoundary=".category-popup-overlay" (mousedown)="$event.stopPropagation()">
      <div class="category-popup-header" cdkDragHandle>
        <h3>Category Lookup</h3>
        <button class="close-btn" (click)="closeDiscretionaryCategoryPopup()" title="Close">✕</button>
      </div>
      <div class="category-popup-content category-popup-single-column">
        <!-- Activities Column (Single list showing Parent - Child) -->
        <div class="activity-column activity-column-full">
          <div class="activity-search-box">
            <input type="text" placeholder="Search activities..."
                   [(ngModel)]="activitySearchTerm"
                   (ngModelChange)="filterActivities()"
                   class="activity-search-input" />
          </div>
          <div style="padding-left:12px; padding-top:12px; display: flex; gap:8px; align-items: center; justify-content: space-between;">
            <input type="checkbox" (change)="($event.target.checked ? selectAllVisibleActivities() : clearAllVisibleActivities())" />
            <!-- NEW: toggle to show only selected -->
            <label style="margin-left:8px; display:inline-flex; align-items:center; gap:6px; padding-right:24px">
              <input type="checkbox" [checked]="showOnlySelectedActivities" (change)="toggleShowOnlySelectedActivities()" />
              <span style="font-size:12px; color:#243b6b; font-weight:600;">Show selected only</span>
            </label>
          </div>
          <div class="activity-checkbox-list" [class.empty-list]="filteredActivitiesList.length ===0">
            <div *ngIf="filteredActivitiesList.length ===0" class="empty-list-message">
              No activities found
            </div>
            <label *ngFor="let activity of filteredActivitiesList" class="activity-checkbox-item">
              <input type="checkbox"
                     [checked]="isActivitySelected(activity)"
                     (change)="toggleActivity(activity)" />
              <span class="checkbox-label">{{ activity.parent }} - {{ activity.child }}</span>
            </label>
          </div>
        </div>
      </div>

      <div class="category-popup-footer">
        <button class="btn btn-secondary" (click)="closeDiscretionaryCategoryPopup()">Cancel</button>
        <button class="btn btn-primary" (click)="applyDiscretionaryCategories()">Save</button>
      </div>
    </div>
  </div>
</ng-container>
